import { vec3 } from 'gl-matrix';
import { GltfAnimation } from '../GltfAnimation';

export interface IkChainDef {
  rootName: string;
  midName: string;
  tipName: string;
}

export class IkChain {
  public target = vec3.create();
  public poleTarget = vec3.create();
  public weight = 1;
  public enabled = true;
  /** World-space Y offset from floor to ankle joint (sole thickness). */
  public footOffset = 0;

  /** Optional child bone index after tip (e.g., toe bone). */
  public childIndex?: number;
  public childName?: string;

  constructor(
    public readonly rootIndex: number,
    public readonly midIndex: number,
    public readonly tipIndex: number,
    public readonly rootName: string,
    public readonly midName: string,
    public readonly tipName: string,
  ) {}
}

interface LegChainPattern extends IkChainDef {
  childName: string;
}

const LEG_CHAIN_PATTERNS: LegChainPattern[] = [
  {
    rootName: 'LeftUpLeg',
    midName: 'LeftLeg',
    tipName: 'LeftFoot',
    childName: 'LeftToeBase',
  },
  {
    rootName: 'RightUpLeg',
    midName: 'RightLeg',
    tipName: 'RightFoot',
    childName: 'RightToeBase',
  },
];

export function discoverLegChains(animation: GltfAnimation): IkChain[] {
  const chains: IkChain[] = [];
  for (const pattern of LEG_CHAIN_PATTERNS) {
    const chain = resolveChain(animation, pattern);
    if (chain) chains.push(chain);
  }
  return chains;
}

function resolveChain(animation: GltfAnimation, def: LegChainPattern): IkChain | null {
  const rootIndex = animation.getJointIndex(def.rootName);
  const midIndex = animation.getJointIndex(def.midName);
  const tipIndex = animation.getJointIndex(def.tipName);
  if (rootIndex === undefined || midIndex === undefined || tipIndex === undefined) {
    return null;
  }
  const chain = new IkChain(rootIndex, midIndex, tipIndex, def.rootName, def.midName, def.tipName);
  const childIndex = animation.getJointIndex(def.childName);
  if (childIndex !== undefined) {
    chain.childIndex = childIndex;
    chain.childName = def.childName;
  }
  return chain;
}
